import React from 'react';
import './textField.scss'

function TextField(props) {
  const className = `text-field__${props.type}`

  return (
    <div className={className}>
      {props.icon}
      <span>{props.title}</span>
      <p>{props.description}</p>
    </div>
  );
}

export default TextField;